import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {delay, first, take, takeUntil, tap} from "rxjs/operators";
import {Observable, of, ReplaySubject} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormAddService} from "../../../shared/services/form-add.service";
import {HttpErrorResponse} from "@angular/common/http";
import {Form} from "../../../shared/interface/form";
import {MatDialog} from "@angular/material/dialog";
import {AddEmailToFormDialogComponent} from "../add-email-to-form-dialog/add-email-to-form-dialog.component";
import {Uuid} from "../../../shared/interface/response/uuid";
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {co} from "@fullcalendar/core/internal-common";
import {UserService} from "../../../shared/services/user.service";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {User} from "../../../shared/interface/user";
@Component({
  selector: 'app-add-dynamic-form',
  templateUrl: './add-dynamic-form.component.html',
  styleUrls: ['./add-dynamic-form.component.scss']
})
export class AddDynamicFormComponent implements OnInit, AfterViewInit {
  @Output() closeModification = new EventEmitter<any>();
  @Output() dynamicFormCreated = new EventEmitter<string>();
  @Input() dynamicForm?: Observable<Form>;
  formObject: Form;
  emailToFormArray = [];
  addFormForm: FormGroup;
  activeControl: FormControl;
  nameControl: FormControl;
  linkControl: FormControl;
  linkToFormControl: FormControl;
  emailTitleControl: FormControl;
  activeMailSendControl: FormControl;
  structureSendControl: FormControl;
  ownerSendControl: FormControl;
  serviceTimeControl: FormControl;
  permissionUserControl: FormControl;
  serviceTimeInput: FormControl;
  contentEmailControl: FormControl;
  creatingAccountControl: FormControl;
  emailReturnToSenderControl: FormControl;
  contentEmailToReturnToSenderControl: FormControl;
  subjectEmailToReturnToSenderControl: FormControl;
  temptable = '{{tabela}}';
  mailAccept = false;
  serviceTimeAccept = false;
  structureAccept = false;
  ownerSend = false;
  processingRequest = false;
  emailContent = false;
  items: User[] = [];
  namesArray: string[];
  user: User;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '100px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Wprowadź treść email..',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      [
        'insertImage',
        'insertVideo',
      ]
    ]
  };

  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formAddService: FormAddService,
    private userService: UserService,
  ) {
  }

  ngOnInit(): void {
    // this.userService.getUserNotCountedListSubject()
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe((response: ListResponse<User>) => {
    //     this.items = response.items;
    //   });
    if (this.dynamicForm) {
      this.dynamicForm
        .pipe(takeUntil(this.destroyed$))
        .subscribe((form: Form) => {
          this.formObject = form;
          this.initialize(form);
        });
    }
    this.addFormForm = this.fb.group({
      emailAddressList: this.fb.array(this.emailToFormArray, []),
      name: this.nameControl = this.fb.control('', [Validators.required]),
      active: this.activeControl = this.fb.control(false),
      emailSend: this.activeMailSendControl = this.fb.control(false),
      assignStructure: this.structureSendControl = this.fb.control(false),
      emailSendToAssignStructure: this.ownerSendControl = this.fb.control(false),
      sampleLink: this.linkControl = this.fb.control(''),
      serviceTimeCheck: this.serviceTimeControl = this.fb.control(''),
      serviceTime: this.serviceTimeInput = this.fb.control(0),
      contentEmail: this.contentEmailControl = this.fb.control(''),
      creatingAccount: this.creatingAccountControl = this.fb.control(''),
      emailReturnToSender: this.emailReturnToSenderControl = this.fb.control(false),
      contentEmailToReturnToSender: this.contentEmailToReturnToSenderControl = this.fb.control(''),
      subjectEmailToReturnToSender: this.subjectEmailToReturnToSenderControl = this.fb.control(''),
      permissionUser: this.permissionUserControl = this.fb.control([]),
      emailTitle: this.emailTitleControl = this.fb.control(''),
      linkToForm: this.linkToFormControl = this.fb.control(''),
    });
    this.ownerSendControl.disable();
  }

  populateEmailFormArray(): void {
    const emailFormArray = this.addFormForm.get('emailAddressList') as FormArray;
    emailFormArray?.clear();
    this.emailToFormArray.forEach(formGroup => {
      const emailValue = formGroup.get('emailAddressList')?.value;
      emailFormArray?.push(new FormControl(emailValue));
    });
  }

  ngAfterViewInit(): void {
    this.activeMailSendControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        this.mailAccept = val;
      });
    this.ownerSendControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        this.ownerSend = val;
        if (!val){
          // this.linkControl.setValidators([]);
          // this.linkControl.reset();
          this.emailTitleControl.setValidators([]);
          this.emailTitleControl.reset();
        } else {
          this.emailTitleControl.setValidators( [Validators.required]);
        }
      });
    this.emailReturnToSenderControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        if (val) {
          this.contentEmailToReturnToSenderControl.setValidators([Validators.required]);
          this.subjectEmailToReturnToSenderControl.setValidators([Validators.required]);
        } else {
          this.contentEmailToReturnToSenderControl.setValidators([]);
          this.subjectEmailToReturnToSenderControl.setValidators([]);
          this.contentEmailToReturnToSenderControl.reset();
          this.subjectEmailToReturnToSenderControl.reset();
        }
      });

    this.structureSendControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        this.structureAccept = val;
        if (!val) {
          this.ownerSend = false;
          this.ownerSendControl.setValue(false);
          this.linkControl.setValidators([]);
          this.linkControl.reset();
          this.linkControl.updateValueAndValidity();
          this.ownerSendControl.disable();
        } else {
          this.ownerSendControl.enable();
          this.linkControl.setValidators([Validators.required]);
          this.linkControl.updateValueAndValidity();
        }
      });


    this.serviceTimeControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        if (val === false){
          this.serviceTimeInput.setValue(0);
        }
        this.serviceTimeAccept = val;
      });
  }

  openModal(): void {
    const dialogRef = this.dialog.open(AddEmailToFormDialogComponent, {
      width: '1200px',
      maxHeight: '400px',
      data: {activeStateOfArray: this.emailToFormArray},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.emailToFormArray = result;
      }
    });
  }

  removeMail(index: number): void {
    this.emailToFormArray.splice(index, 1);
  }

  save(): void {
    if (this.processingRequest ===  true)
    {
      return;
    }else {
      this.processingRequest = true;
    }
    this.populateEmailFormArray();
    if (!this.addFormForm.valid) {
      this.addFormForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.addFormForm.getRawValue().emailAddressList = this.emailToFormArray;
    this.formAddService.sendForm(
      this.addFormForm.getRawValue(),
      this.formObject ? this.formObject.uuid : null)
      .pipe(first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open(this.formObject ? 'Pomyślnie zaktualizowano Formularz' : 'Pomyślnie utworzono Formularz', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        if (!this.formObject) {
          this.router.navigate(['/formularze/szczegoly/', response.uuid]);
        } else {
          this.closeModification.emit();
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas tworzenia obiektu Formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      })
    ;
  }

  cancel(): void {
    if(this.formObject) {
      this.router.navigate(['/formularze/szczegoly/', this.formObject?.uuid]);
      this.closeModification.emit();
    } else {
      this.router.navigate(['/formularze/']);

    }
  }

  check(): void {
  }

  initialize(form: Form): void {
    of(form)
      .pipe(
        delay(0),
        tap(() => {
          form?.emailAddressList.forEach((email) => {
            const emailFormGroup = this.fb.group({
              emailAddressList: [email, []]
            });
            this.emailToFormArray.push(emailFormGroup);
          });
          this.addFormForm.reset({
            emailAddressList: form?.emailAddressList,
            name: form?.name,
            active: form?.active,
            emailSend: form?.emailSend,
            assignStructure: form?.assignStructure,
            emailSendToAssignStructure: form?.emailSendToAssignStructure,
            sampleLink: form?.sampleLink,
            serviceTimeCheck: form?.serviceTime > 0,
            serviceTime: form?.serviceTime,
            contentEmail: form?.contentEmail,
            creatingAccount: form?.creatingAccount,
            emailReturnToSender: form?.emailReturnToSender,
            contentEmailToReturnToSender:  form?.contentEmailToReturnToSender,
            subjectEmailToReturnToSender: form?.subjectEmailToReturnToSender,
            permissionUser: form?.permissionUser,
            emailTitle: form?.emailTitle,
            linkToForm: form?.linkToForm,
          });
          this.initialized.next(true);
        })
      ).subscribe();
  }
}

